import url from "/vercel/path0/src/pages/ReportingAndDocuments/imgs/folder.svg?url";
export default url;
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolder = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 35,
	viewBox: "0 0 44 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M39.332 4.4974H21.9987L17.6654 0.164062H4.66536C2.28203 0.164062 0.353698 2.11406 0.353698 4.4974L0.332031 30.4974C0.332031 32.8807 2.28203 34.8307 4.66536 34.8307H39.332C41.7154 34.8307 43.6654 32.8807 43.6654 30.4974V8.83073C43.6654 6.4474 41.7154 4.4974 39.332 4.4974ZM39.332 30.4974H4.66536V8.83073H39.332V30.4974Z",
		fill: "#0089BD"
	})]
});
const ForwardRef = forwardRef(SvgFolder);
export { ForwardRef as ReactComponent };
